module.exports = __webpack_public_path__ + "img/itovi_blue.ae37869e.png";